module.exports = __webpack_public_path__ + "static/media/cash.bcfb7b44.svg";